import React from 'react';
import { parse24, to24 } from '@/lib/time12';

const HOURS = Array.from({ length: 12 }, (_, i) => i + 1);
const MINUTES = Array.from({ length: 12 }, (_, i) => i * 5);

// 12-hour time picker (hour · minute · AM/PM). Native <input type="time"> follows
// the computer's 24h/12h setting, so Deskey uses this to always show 12-hour.
// `value` / `onChange` use "HH:MM" (24-hour) so stored data stays the same.
export default function TimeSelect12h({ value, onChange, allowEmpty = false, testId, className = '' }) {
  const parsed = parse24(value);
  const cur = parsed || { hour12: 12, minute: 0, period: 'AM' };
  // Keep an unusual stored minute (e.g. 07) selectable instead of silently snapping it.
  const minutes = MINUTES.includes(cur.minute) ? MINUTES : [...MINUTES, cur.minute].sort((a, b) => a - b);
  const set = (patch) => {
    const next = { ...cur, ...patch };
    onChange(to24(next.hour12, next.minute, next.period));
  };
  const sel = 'h-10 rounded-lg border border-zinc-200 bg-white px-2 text-[13px] focus:outline-none focus:ring-2 focus:ring-emerald-200';
  if (allowEmpty && !parsed) {
    return (
      <button type="button" onClick={() => onChange('09:00')} className={`${sel} w-full text-left text-zinc-400 ${className}`} data-testid={testId}>
        Set time
      </button>
    );
  }
  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid={testId}>
      <select aria-label="Hour" value={cur.hour12} onChange={e => set({ hour12: Number(e.target.value) })} className={sel}>
        {HOURS.map(h => <option key={h} value={h}>{h}</option>)}
      </select>
      <span className="text-zinc-400 font-bold">:</span>
      <select aria-label="Minute" value={cur.minute} onChange={e => set({ minute: Number(e.target.value) })} className={sel}>
        {minutes.map(m => <option key={m} value={m}>{String(m).padStart(2, '0')}</option>)}
      </select>
      <select aria-label="AM or PM" value={cur.period} onChange={e => set({ period: e.target.value })} className={sel}>
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
      {allowEmpty && (
        <button type="button" onClick={() => onChange('')} className="text-[11px] text-zinc-400 hover:text-zinc-600 ml-1">Clear</button>
      )}
    </div>
  );
}
